import React from 'react'

import { Link } from 'react-router-dom'

import { FaEdit, FaTrash } from 'react-icons/fa'

import Activity from '../../../../services/Activity'

import './styles.css'

function ActivityItem({ id, title, description, link, handleDelete }) {
  const remove = () => {
    Activity.delete(id).then(() => {
      handleDelete()
    })
  }

  return (
    <li id="activity-item-content">
      <div className="info-content">
        <span>{title}</span>
        <p>{description}</p>
        <div className="link-activity-content">
          <a href={link}>Acessar atividade</a>
        </div>
      </div>
      <div className='operations-content'>
        <Link className="link-operation edit" to={`/admin/activity/${id}`}>
          <FaEdit />
        </Link>
          <button
            className="link-operation trash"
            onClick={remove}
          >
          <FaTrash />
        </button>
      </div>
    </li>
  )
}

export default ActivityItem